import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=d9d5d9ca&scoped=true"
import script from "./GoTop.vue?vue&type=script&lang=js"
export * from "./GoTop.vue?vue&type=script&lang=js"
import style0 from "./GoTop.vue?vue&type=style&index=0&id=d9d5d9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d5d9ca",
  null
  
)

export default component.exports